import { NotificationContext } from '@tcs/client-portal-common/providers/NotificationProvider';
import { Status } from '@tcs/common/types';
import { useQuery } from '@tcs/common/hooks/useQuery';
import { differenceInHours, format } from 'date-fns';
import { toZonedTime, toDate } from 'date-fns-tz';
import { useContext, useEffect } from 'react';

const useReportNotifications = () => {
  const { addNotification, clearNotification } =
    useContext(NotificationContext);

  const { data: lastSyncDate, isLoading: loading } = useQuery<string, Error>(
    `/dataAsOf`,
    {
      refetchOnMount: true,
      refetchInterval: 5 * 60 * 1000,
    }
  );

  useEffect(() => {
    if (loading || !lastSyncDate) {
      return;
    }

    try {
      const syncDate = toDate(lastSyncDate, {
        timeZone: 'America/Los_Angeles',
      });
      const now = new Date();
      const hoursSinceSync = differenceInHours(now, syncDate);
      const nowPT = toZonedTime(now, 'America/Los_Angeles');

      if (hoursSinceSync > 24 && nowPT.getHours() >= 8) {
        const formattedDate = format(syncDate, 'MMMM d, yyyy');

        addNotification(
          {
            text: `Report data may be outdated. Last successful sync was on ${formattedDate}.`,
            status: 'warning' as Status,
            type: 'sync-status',
          },
          true,
          true
        );
      } else {
        clearNotification('sync-status');
      }
    } catch (error) {
      console.error('Error checking sync status:', error);
    }
  }, [loading, lastSyncDate, addNotification, clearNotification]);
};

export default useReportNotifications;
